import { getApiUrl } from "src/common/api/getUrl";
import { dataParser } from "src/common/dataParser";
import { mdmLoader } from "src/common/mdmLoader";
import { rest } from "src/common/rest";
import { ZId } from "src/types";
import { ZUser, zUser } from "src/types/ZUser";

import { UserSaveData } from "../../pages/management/usersAndRoles/users/types";

export const loadUsers = () => mdmLoader(zUser, getApiUrl(`/core/users`));
// Получение пользователя по ID
export const loadUser = async (userId: string): Promise<ZUser> => {
  const resp = await rest.get(getApiUrl(`/core/users/${userId}`));
  const data = dataParser(() => zUser.parse(resp.data), "user response");
  return data;
};

// Обновление пользователя
export const updateUser = async (
  userId: ZId,
  userData: UserSaveData,
): Promise<ZUser> => {
  const resp = await rest.put(getApiUrl(`/core/users/${userId}`), userData);
  const data = dataParser(
    () => zUser.parse(resp.data),
    "updated user response",
  );
  return data;
};

// Создание пользователя
export const createUser = async (userData: UserSaveData): Promise<ZUser> => {
  const resp = await rest.post(getApiUrl("/core/users"), userData);
  const data = dataParser(
    () => zUser.parse(resp.data),
    "created user response",
  );
  return data;
};
